.page {
  max-width: 1200px;
  margin: 0 auto;
  padding: var(--page-pad-y) var(--page-pad-x) clamp(40px, 5vw, 80px);
  background: #fff;
  container-type: inline-size;
  container-name: cart;
}

.head {
  display: flex;
  align-items: baseline;
  gap: 14px;
  flex-wrap: wrap;
  margin-bottom: 8px;
}

.title {
  font-family: var(--font-display);
  font-size: var(--fs-2xl);
  font-weight: 800;
  margin: 0;
  letter-spacing: 0.04em;
}

.subtitle {
  color: var(--color-ink-soft);
  font-size: 0.9rem;
}

.empty {
  padding: 60px 20px;
  text-align: center;
  color: var(--color-ink-soft);
}

.emptyLink {
  color: var(--color-ember-dark);
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  text-decoration: none;
}

.creditAlert {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 14px 16px;
  background: rgba(181, 59, 59, 0.08);
  border: 1px solid rgba(181, 59, 59, 0.4);
  color: #7a2828;
  border-radius: 8px;
  margin: 14px 0;
  font-size: 0.9rem;
}

.creditAlert strong { font-size: 0.95rem; }

.creditChip {
  display: inline-flex;
  align-items: baseline;
  gap: 8px;
  padding: 8px 14px;
  background: rgba(46, 157, 87, 0.1);
  color: #226c40;
  border-radius: 999px;
  margin: 8px 0 4px;
  font-size: 0.85rem;
  font-weight: 600;
}

.layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(280px, 360px);
  gap: clamp(24px, 3vw, 40px);
  margin-top: 12px;
}

.lines {
  border-top: 1px solid rgba(0, 0, 0, 0.08);
}

.summary { min-width: 0; }

.saved {
  margin-top: 32px;
  border-top: 2px solid var(--color-ink);
  padding-top: 16px;
}

.savedTitle {
  font-family: var(--font-display);
  font-size: 1.1rem;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  margin: 0 0 12px;
}

.savedRow {
  display: grid;
  grid-template-columns: 64px 1fr auto;
  gap: 12px;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.savedThumb img {
  width: 64px;
  height: 64px;
  object-fit: cover;
  border-radius: 4px;
  background: var(--color-bone);
}

.savedMeta { min-width: 0; }
.savedName { font-weight: 600; font-size: 0.95rem; }
.savedSub { font-size: 0.78rem; color: var(--color-ink-soft); margin-top: 2px; }

.savedActions {
  display: flex;
  gap: 8px;
}

.linkBtn {
  background: transparent;
  border: 0;
  color: var(--color-ember-dark);
  cursor: pointer;
  font: inherit;
  font-size: 0.78rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  font-weight: 700;
  padding: 4px;
}

.linkBtn:hover { color: var(--color-ink); }

@container cart (max-width: 820px) {
  .layout { grid-template-columns: 1fr; gap: clamp(20px, 3vw, 24px); }
  .summary > * { position: static !important; }
}
